import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-email-rates',
  templateUrl: './email-rates.component.html',
  styleUrls: ['./email-rates.component.scss']
})
export class EmailRatesComponent implements OnInit {


  @Input() contact = {
    propertyAddress: {
      state: '',
      street: '',
      streetCont: '',
      city: '',
      zip: '',

    },
    firstname: '',
    lastname: '',
    email: '',
    phone: ''
  };
  @Output() backEmitter = new EventEmitter();
  @Output() emailNowEmitter = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  back() {
    this.backEmitter.emit();
  }

  getPhoneFormat() {
    return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  emailNow() {
    this.emailNowEmitter.emit(this.contact);
  }

  checkForm() {
    return this.contact.firstname && this.contact.lastname && this.contact.email;
  }
}
